


import { miniImage } from '../../utils/util'

import { useDispatch } from 'react-redux';
import { MiniGroup } from '../../redux/entities';


function groupId(imageId, creatureId) {
    return "img-" + creatureId + "-" + imageId;
}

// Flat token render (MINI-24): no foot/fold/mirror/label — just the art clipped
// to a rectangle or a circle. The chosen size maps to the longest side of the
// image; for round tokens the circle diameter equals that longest side.
function TokenImage(props) {
    const { creature, imageId, round } = props;
    const size = (props.sizeOverride || creature.size || 1);
    const ratio = creature.heightRatio || 1;

    // Longest side = size. Wide/square art fills the width; tall art fills the height.
    const imgWidth = ratio <= 1 ? size : size / ratio;
    const imgHeight = ratio <= 1 ? size * ratio : size;

    if (round) {
        const d = size; // circle diameter = longest side
        const r = d / 2;
        const ix = (d - imgWidth) / 2;
        const iy = (d - imgHeight) / 2;
        const clipId = `token-clip-${imageId}`;
        return (
            <svg viewBox={`0 0 ${d} ${d}`} id={imageId}>
                <defs>
                    <clipPath id={clipId}><circle cx={r} cy={r} r={r} /></clipPath>
                </defs>
                <image href={miniImage(creature)} x={ix} y={iy} width={imgWidth} height={imgHeight}
                    preserveAspectRatio="xMidYMid meet" clipPath={`url(#${clipId})`} />
                <circle cx={r} cy={r} r={r} fill="none" stroke="grey" strokeWidth={0.01} />
            </svg>
        );
    }

    return (
        <svg viewBox={`0 0 ${imgWidth} ${imgHeight}`} id={imageId}>
            <image href={miniImage(creature)} width={imgWidth} height={imgHeight}
                preserveAspectRatio="xMidYMid meet" />
            <rect x={0} y={0} width={imgWidth} height={imgHeight} fill="none" stroke="grey" strokeWidth={0.01} />
        </svg>
    );
}

export function MiniImage(props) {
    const { creature, imageId, vertical, label = '', sizeOverride, renderStyle = 'standee' } = props; // size in inches

    if (renderStyle === 'rectToken' || renderStyle === 'roundToken') {
        return <TokenImage creature={creature} imageId={imageId} sizeOverride={sizeOverride} round={renderStyle === 'roundToken'} />;
    }

    const size = (sizeOverride || creature.size || 1);
    // console.log("MiniImage: ", creature, props, size )

    const width = size;
    const creatureHeight = creature.heightRatio * size;

    const gid = groupId(imageId, creature.id);
    const labelId = "label-" + gid;

    const r = width / 2;
    const baseHeight = r; // because half base, used twice

    // console.log("locals", props)
    const height = (baseHeight + creatureHeight); // add size to make room for the base
    const baseY = (vertical ? height * 2 : height) - baseHeight;

    const mirrored = vertical ?
        (<use href={"#" + gid} transform={`scale(1,-1) translate(0, ${-(vertical ? height * 2 : height)})`} />) :
        (<use href={"#" + gid} transform={`scale(-1,1) translate(-${2 * width}, 0)`} />);

    const mirroredLabel = vertical ? 
        (<use href={'#'+labelId} transform={`rotate(180, ${width/2}, ${height})`} />) :
        (<use href={'#'+labelId} transform={`translate(${width}, 0)`} />)



    const foldLine = vertical ?
        (<line x1={0} y1={height} x2={width} y2={height} strokeDasharray="0.01 0.1" stroke="grey" strokeWidth={0.01} />) :  // css here doesn't carry over to print
        (<line x1={width} y1={0} x2={width} y2={creatureHeight} strokeDasharray="0.01 0.1" stroke="grey" strokeWidth={0.01} />);

    return (
        <svg viewBox={"0 0 " + width * (vertical ? 1 : 2) + " " + (vertical ? height * 2 : height)} id={imageId} >
            <g id={gid} >
                <image href={miniImage(creature)} id={imageId} width={width} height={creatureHeight} preserveAspectRatio="xMidYMax meet" y={vertical ? height : 0} clipPath={`url(#mini-area-${creature.id})`} />
                <g stroke="grey" fill="transparent" strokeWidth="0.02" >
                    <rect x="0" y={baseY} width={width} height={baseHeight} rx="0.02" stroke="transparent" />
                    <path id={"footer-" + imageId} d={`M${width},${baseY} A ${baseHeight},${baseHeight} 0 0 1 ${0},${baseY}`} />
                    <line x1={0} y1={baseY} x2={width} y2={baseY} strokeDasharray="0.01 0.1" stroke="grey" strokeWidth={0.01} />
                </g>

            </g>
            {mirrored}
            <g id={labelId}>
                <svg x={0} y={baseY} width={width} height={baseHeight} viewBox="0 0 100 50">
                    <text textAnchor='middle' fontFamily='serif' fontSize='120%' fill='black' x={50} y={18}>{label ? label : ""}</text>
                </svg>
            </g>
            {mirroredLabel}

            {foldLine}
        </svg>
    )
}


/**
 * 
 * Use like this
 * 
 * <MiniController mini={theMiniToControl}>
 *   { control => (
 *      <YourMiniView mini={control.mini} onUpdate={newValues => controller.doUpdate(newValues) }/>
 *     )
 *   }
 * </MiniController>
 * 
 * @param {mini}  
 */
export function MiniGroupController(props) {
    const { group } = props;
    const dispatch = useDispatch();

    async function doUpdate(updates) {
        const updated = { ...group, ...updates };
        console.log("updating", updated);

        dispatch(MiniGroup.actions.updateEntityAsync(updated)).then(result => console.log("result ", result));
    }

    async function doDelete() {
        console.log("deleting", group);
        dispatch(MiniGroup.actions.removeEntityAsync(group)).then(result => console.log("deleted ", result));
    }

    return props.children({ group, doUpdate, doDelete })

}